import {
  Box,
  Typography,
  Stack,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../assets/svg/Logo.svg";
import { ReactComponent as TabletLogo } from "../../assets/svg/TabletLogo.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/BackIcon.svg";
import CInput from "../../components/CInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { Setting } from "../../utils/Setting";
import { getApiData } from "../../utils/APIHelper";
import { useDispatch } from "react-redux";
import authActions from "../../redux/reducers/auth/actions";
import { store } from "../../redux/store/configureStore";
import { useNavigate } from "react-router-dom";
import useStyles from "./styles";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Images from "../../config/images";
import GoogleLoginButton from "../../components/SocialLogin/GoogleLoginButton";
import { useMediaQuery, useTheme } from "@mui/material";

const errorObj = {
  emailErr: false,
  passwordErr: false,
  forgotEmailErr: false,
  emailMsg: "",
  passwordMsg: "",
  forgotEmailMsg: "",
};

function NewLogin() {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const isTablet = useMediaQuery("(max-width:1024px)");
  const isMobile = useMediaQuery("(max-width:820px)");
  const classes = useStyles();

  const {
    setUserData,
    setToken,
    setContractorRoles,
    setUserRoleWithPermissions,
  } = authActions;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errObj, setErrObj] = useState(errorObj);
  const [btnLoad, setBtnLoad] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [visibleForgotModal, setVisibleForgotModal] = useState(false);
  const [locationData, setLocationData] = useState({});
  const [socialBtnLoad, setSocialBtnLoad] = useState(false);

  // this function for to get location detail
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => setLocationData(data))
      .catch((error) => console.error(error));
  }, []);

  function validation() {
    const error = { ...errObj };
    let valid = true;

    // validate email
    if (isEmpty(email)) {
      valid = false;
      error.emailErr = true;
      error.emailMsg = "Please enter email";
    } else if (!emailRegex.test(email)) {
      valid = false;
      error.emailErr = true;
      error.emailMsg = "Please enter valid email";
    }

    // validate password
    if (isEmpty(password)) {
      valid = false;
      error.passwordErr = true;
      error.passwordMsg = "Please enter password";
    } else if (password.length < 8) {
      valid = false;
      error.passwordErr = true;
      error.passwordMsg = "Password length must be of 8-15";
    }

    setErrObj(error);
    if (valid) {
      loginUser();
    }
  }

  async function loginUser() {
    setBtnLoad(true);
    const address = `${locationData?.city ? locationData?.city + "," : ""} ${
      locationData?.region ? locationData?.region + "," : ""
    } ${locationData?.country_name || ""}`;
    try {
      const response = await getApiData(`api/contractor/login`, "POST", {
        email,
        password,
        device_type: "web",
        device_name: locationData?.ip || "",
        login_address: address,
      });

      const socialData = {
        email,
        password,
      };

      if (response.success) {
        console.log("------", response, ">>>>>>response");

        dispatch(setToken(response?.token));
        dispatch(setUserData(response?.data));

        // Fetch contractor roles after successful login and store user's role permissions
        const rolesFetched = await fetchContractorRoles();
        if (rolesFetched) {
          await setUserRolePermissions(response?.data?.role);
        }

        if (response?.is_new_user) {
          navigate("/signup", { state: { socialData } });
        } else if (response?.is_role_added === false) {
          navigate("/role");
        } else if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else {
          // Check if user has a non-standard role (doesn't require profile creation)
          const standardRoles = ["designer", "contractor", "supplier"];
          const isNonStandardRole =
            response?.data?.role &&
            !standardRoles.includes(response?.data?.role);

          // Non-standard roles skip profile creation even if pending
          if (
            !isNonStandardRole &&
            response?.data?.contractor_data &&
            response?.data?.contractor_data?.profile_completed === "pending"
          ) {
            navigate("/create-profile");
          } else {
            // Check if user has contractor access (contractor or contractor_project_manager)
            const userRole = response?.data?.role;
            const hasContractorAccess =
              userRole === "contractor" ||
              userRole === "contractor_project_manager";

            if (hasContractorAccess) {
              const hasProjects = await getProjectList();
              if (hasProjects) {
                navigate("/dashboard");
              } else {
                const hasProposals = await getProposalList();
                if (hasProposals) {
                  navigate("/proposals");
                } else {
                  navigate("/account-setting");
                }
              }
            } else {
              // For non-contractor roles, go directly to dashboard or account settings
              navigate("/dashboard");
            }
          }
        }
      } else {
        dispatch(setToken(response?.token));
        dispatch(setUserData(response?.data));

        // Fetch contractor roles after successful login (even if response.success is false) and store user's role permissions
        const rolesFetched = await fetchContractorRoles();
        if (rolesFetched) {
          await setUserRolePermissions(response?.data?.role);
        }

        if (response?.is_new_user) {
          navigate("/signup", { state: { socialData } });
        } else if (response?.is_role_added === false) {
          navigate("/role");
        } else if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else if (response.is_role_added === false) {
          navigate("/role");
        } else {
          // Check if user has a non-standard role (doesn't require profile creation)
          const standardRoles = ["designer", "contractor", "supplier"];
          const isNonStandardRole =
            response?.data?.role &&
            !standardRoles.includes(response?.data?.role);

          // Non-standard roles skip profile creation even if pending
          if (
            !isNonStandardRole &&
            response?.data?.contractor_data &&
            response?.data?.contractor_data?.profile_completed === "pending"
          ) {
            navigate("/create-profile");
          } else {
            // Check if user has contractor access (contractor or contractor_project_manager)
            const userRole = response?.data?.role;
            const hasContractorAccess =
              userRole === "contractor" ||
              userRole === "contractor_project_manager";

            if (hasContractorAccess) {
              const hasProjects = await getProjectList();
              if (hasProjects) {
                navigate("/dashboard");
              } else {
                const hasProposals = await getProposalList();
                if (hasProposals) {
                  navigate("/proposals");
                } else {
                  navigate("/account-setting");
                }
              }
            } else {
              // For non-contractor roles, go directly to dashboard or account settings
              navigate("/dashboard");
            }
          }
        }
        toast.error(response.message);
      }
      setBtnLoad(false);
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ loginUser ~ error:", error);
      setBtnLoad(false);
      toast.error(error.toString());
    }
  }

  async function getProjectList() {
    try {
      const response = await getApiData(
        `api/project/list-contractor-project?status=ongoing,delivered,in_warranty,completed`,
        "GET",
        {},
        {},
        false
      );
      if (!response?.success) {
        return false; // Return false if API call was not successful
      }
      const newDetails = response?.data || [];
      return newDetails.length > 0; // Returns true if projects exist, false otherwise
    } catch (error) {
      console.error("Something went wrong", error);
      return false;
    }
  }

  async function getProposalList() {
    try {
      const response = await getApiData(
        `api/project/list-contractor-project`,
        "GET",
        {},
        {},
        false
      );
      if (!response?.success) {
        return false; // Return false if API call was not successful
      }
      const newDetails = response?.data || [];
      return newDetails.length > 0; // Returns true if proposal exist, false otherwise
    } catch (error) {
      console.error("Something went wrong", error);
      return false;
    }
  }

  async function fetchContractorRoles() {
    try {
      console.log("🔍 [DEBUG] fetchContractorRoles: Starting API call...");
      console.log(
        "🔍 [DEBUG] fetchContractorRoles: API endpoint:",
        Setting.endpoints.roles(0, 7, "CONTRACTOR", true)
      );

      const response = await getApiData(
        Setting.endpoints.roles(0, 7, "CONTRACTOR", true),
        "GET",
        {},
        {},
        true // Use newBaseUrl (isAlternateUrl = true)
      );

      console.log(
        "🔍 [DEBUG] fetchContractorRoles: Full API Response:",
        JSON.stringify(response, null, 2)
      );
      console.log(
        "🔍 [DEBUG] fetchContractorRoles: Response type:",
        typeof response
      );
      console.log(
        "🔍 [DEBUG] fetchContractorRoles: Response keys:",
        response ? Object.keys(response) : "null"
      );

      // Handle different response structures (content for paginated, data for direct)
      let roles = null;
      if (response?.content && Array.isArray(response.content)) {
        console.log(
          "🔍 [DEBUG] fetchContractorRoles: Found roles in response.content"
        );
        roles = response.content;
      } else if (response?.data && Array.isArray(response.data)) {
        console.log(
          "🔍 [DEBUG] fetchContractorRoles: Found roles in response.data"
        );
        roles = response.data;
      } else if (
        response?.data?.content &&
        Array.isArray(response.data.content)
      ) {
        console.log(
          "🔍 [DEBUG] fetchContractorRoles: Found roles in response.data.content"
        );
        roles = response.data.content;
      } else if (Array.isArray(response)) {
        console.log(
          "🔍 [DEBUG] fetchContractorRoles: Response is directly an array"
        );
        roles = response;
      } else {
        console.warn(
          "🔍 [DEBUG] fetchContractorRoles: Could not find roles array in response structure"
        );
      }

      console.log("🔍 [DEBUG] fetchContractorRoles: Extracted roles:", roles);
      console.log(
        "🔍 [DEBUG] fetchContractorRoles: Roles count:",
        roles ? roles.length : 0
      );

      // Ensure "contractor" role is included since it's not returned from the database
      if (roles && Array.isArray(roles)) {
        // Check if "contractor" already exists in the array
        const hasContractor = roles.some((role) => {
          // Handle both string roles and object roles
          if (typeof role === "string") {
            return role === "contractor";
          } else if (typeof role === "object" && role !== null) {
            return (
              role.name === "contractor" ||
              role.type === "contractor" ||
              role.id === "contractor" ||
              role.roleType === "contractor"
            );
          }
          return false;
        });

        // Add "contractor" if it doesn't exist
        if (!hasContractor) {
          // If roles are objects, add as an object; otherwise add as a string
          const firstRole = roles[0];
          if (typeof firstRole === "object" && firstRole !== null) {
            // Add as object with common structure
            roles.unshift({ name: "contractor", type: "contractor" });
          } else {
            // Add as string
            roles.unshift("contractor");
          }
        }

        // Store roles in Redux
        console.log(
          "🔍 [DEBUG] fetchContractorRoles: Dispatching setContractorRoles with:",
          roles
        );
        dispatch(setContractorRoles(roles));

        // Verify roles were stored in Redux
        const stateAfterDispatch = store.getState();
        console.log(
          "🔍 [DEBUG] fetchContractorRoles: Redux state after dispatch:",
          {
            contractorRoles: stateAfterDispatch.auth.contractorRoles,
            contractorRolesLength:
              stateAfterDispatch.auth.contractorRoles?.length,
          }
        );

        return roles;
      } else if (!roles) {
        // If no roles were fetched, at least add "contractor"
        const defaultRoles = ["contractor"];
        dispatch(setContractorRoles(defaultRoles));
        return defaultRoles;
      }
      return null;
    } catch (error) {
      console.error(
        "🔍 [DEBUG] fetchContractorRoles: ERROR - Failed to fetch roles:",
        error
      );
      console.error("🔍 [DEBUG] fetchContractorRoles: Error details:", {
        message: error?.message,
        stack: error?.stack,
        response: error?.response,
        status: error?.status,
      });
      // Even if API fails, add "contractor" role as fallback
      const fallbackRoles = ["contractor"];
      console.log(
        "🔍 [DEBUG] fetchContractorRoles: Using fallback roles:",
        fallbackRoles
      );
      dispatch(setContractorRoles(fallbackRoles));
      return fallbackRoles;
    }
  }

  async function setUserRolePermissions(userRole) {
    try {
      if (!userRole) {
        console.log("🔍 [DEBUG] setUserRolePermissions: No userRole provided");
        return;
      }

      console.log(
        "🔍 [DEBUG] setUserRolePermissions: Looking for role:",
        userRole
      );

      // Get contractor roles from Redux
      const state = store.getState();
      const contractorRoles = state.auth.contractorRoles;

      console.log("🔍 [DEBUG] Available contractorRoles:", contractorRoles);

      if (!contractorRoles || contractorRoles.length === 0) {
        console.log("🔍 [DEBUG] No contractorRoles found in Redux");
        return;
      }

      // Find the user's specific role object
      // Handle case-insensitive matching since API returns uppercase (e.g., "CONTRACTOR_PROJECT_MANAGER")
      // but user role might be lowercase (e.g., "contractor_project_manager")
      const normalizedUserRole = userRole?.toUpperCase();
      console.log(
        "🔍 [DEBUG] Normalized userRole to match:",
        normalizedUserRole
      );

      const userRoleObject = contractorRoles.find((r) => {
        if (typeof r === "string") {
          return r.toUpperCase() === normalizedUserRole;
        } else if (typeof r === "object" && r !== null) {
          const match =
            r.name?.toUpperCase() === normalizedUserRole ||
            r.type?.toUpperCase() === normalizedUserRole ||
            r.id === userRole ||
            r.roleType?.toUpperCase() === normalizedUserRole ||
            r.role?.toUpperCase() === normalizedUserRole ||
            r.displayName?.toUpperCase() === normalizedUserRole;
          if (match) {
            console.log("🔍 [DEBUG] Found matching role object:", r);
          }
          return match;
        }
        return false;
      });

      console.log("🔍 [DEBUG] Found userRoleObject:", userRoleObject);

      // Store the user's role object with permissions in Redux
      if (userRoleObject) {
        console.log(
          "🔍 [DEBUG] setUserRolePermissions: Storing userRoleWithPermissions:",
          userRoleObject
        );
        console.log(
          "🔍 [DEBUG] setUserRolePermissions: Role object permissions:",
          userRoleObject.permissions
        );
        dispatch(setUserRoleWithPermissions(userRoleObject));

        // Verify userRoleWithPermissions was stored in Redux
        const stateAfterDispatch = store.getState();
        console.log(
          "🔍 [DEBUG] setUserRolePermissions: Redux state after dispatch:",
          {
            userRoleWithPermissions:
              stateAfterDispatch.auth.userRoleWithPermissions,
            hasUserRoleWithPermissions:
              !!stateAfterDispatch.auth.userRoleWithPermissions,
          }
        );
      } else {
        console.log(
          "🔍 [DEBUG] setUserRolePermissions: No matching role object found for:",
          userRole
        );
        console.log(
          "🔍 [DEBUG] setUserRolePermissions: Available role names:",
          contractorRoles.map((r) =>
            typeof r === "object" ? r.name || r.type || r.displayName : r
          )
        );
        console.log(
          "🔍 [DEBUG] setUserRolePermissions: Full contractorRoles for inspection:",
          contractorRoles
        );
      }
    } catch (error) {
      console.error("Error setting user role permissions:", error);
    }
  }

  async function googleDataApiCall(googleCode) {
    try {
      setSocialBtnLoad("google");
      const response = await getApiData(Setting.endpoints.googleData, "POST", {
        code: googleCode,
      });

      if (response.success) {
        if (!isEmpty(response?.data)) {
          socialLoginApiCall(response?.data, "google");
        }
      } else {
        toast.error(response.message);
        setSocialBtnLoad("");
      }
    } catch (error) {
      console.log("🚀 ~ google data api call ~ error:", error);
      toast.error(error.toString());
      setSocialBtnLoad("");
    }
  }

  async function socialLoginApiCall(socialData, type) {
    setSocialBtnLoad(type);
    const address = `${locationData?.city ? locationData?.city + "," : ""} ${
      locationData?.region ? locationData?.region + "," : ""
    } ${locationData?.country_name || ""}`;
    try {
      const response = await getApiData(Setting.endpoints.login, "POST", {
        email: socialData?.email ? socialData?.email : "",
        password: socialData?.password ? socialData?.password : "",
        device_type: "web",
        social_connection: type ? type : "",
        device_name: locationData?.ip || "",
        login_address: address,
      });

      if (response.success) {
        dispatch(setToken(response?.token));

        // Fetch contractor roles after successful social login and store user's role permissions
        const rolesFetched = await fetchContractorRoles();
        if (rolesFetched) {
          await setUserRolePermissions(response?.data?.role);
        }

        if (response?.is_new_user) {
          setSocialBtnLoad("");
          navigate("/signup", {
            state: { socialData, type, data: response?.data },
          });
        } else if (
          response?.data?.contractor_data &&
          response?.data?.contractor_data?.profile_completed === "pending"
        ) {
          dispatch(setUserData(response?.data));
          navigate("/create-profile");
        } else if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else if (
          response?.is_phone_verified === false ||
          response?.data?.is_phone_verified === false
        ) {
          navigate("/phone-verify", {
            state: { data: response?.data, type: "phone" },
          });
        } else if (response?.is_role_added === false) {
          dispatch(setUserData(response?.data));
          navigate("/role");
        } else if (response?.data?.is_two_factor_verified) {
          dispatch(setUserData(response?.data));
          navigate("/otp-verify", {
            state: {
              data: response?.data,
              type: "email",
              subtype: "two_factor",
            },
          });
        } else if (response.success === false) {
          dispatch(setToken(response?.token));
          if (
            response?.is_email_verified === false ||
            response?.data?.is_email_verified === false
          ) {
            dispatch(setUserData(response?.data));
            navigate("/otp-verify", {
              state: { data: response?.data, type: "email" },
            });
          } else if (
            response?.is_phone_verified === false ||
            response?.data?.is_phone_verified === false
          ) {
            navigate("/phone-verify", {
              state: { data: response?.data, type: "phone" },
            });
          } else {
            setSocialBtnLoad("");
            toast.error(response.message);
          }
        } else {
          dispatch(setUserData(response?.data));
          setSocialBtnLoad("");
          navigate("/dashboard");
        }
      } else {
        setSocialBtnLoad("");
        toast.error(response.message);
      }
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ loginUser ~ error:", error);
      setSocialBtnLoad("");
      toast.error(error.toString());
    }
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: 'url("/assets/images/bg2.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          textAlign: "center",
          px: 3,
          pt: isMobile ? 4 : isTablet ? 4 : 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: isMobile ? "30px" : isTablet ? "15px" : "30px",
            width: isMobile ? "100%" : isTablet ? "60%" : "50%",
          }}
        >
          <div>{isTablet ? <TabletLogo /> : <Logo />}</div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <BackIcon
              onClick={() => navigate("/login")}
              style={{ cursor: "pointer" }}
            />
            <div
              style={{
                width: "100%",
                fontSize: isMobile ? "1.3rem" : isTablet ? "1rem" : "40px",
                fontFamily: "Inter Tight",
                textAlign: "center",
                fontWeight: "600",
                color: "#000000",
                letterSpacing: "-0.4px",
              }}
            >
              Login to Reno
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: isMobile ? "95%" : "55%",
              textAlign: "left",
            }}
          >
            <CInput
              label="Email Address"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrObj({ ...errObj, emailErr: false, emailMsg: "" });
              }}
              white={false}
              error={errObj.emailErr}
              helpertext={errObj.emailMsg}
              className={classes.label}
            />

            <CInput
              label="Password"
              placeholder="Enter password"
              type={showPassword ? "text" : "password"}
              value={password}
              className={classes.label}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrObj({
                  ...errObj,
                  passwordErr: false,
                  passwordMsg: "",
                });
              }}
              onKeyPress={(ev) => {
                if (ev.key === "Enter") {
                  ev.preventDefault();
                  validation();
                }
              }}
              white={false}
              error={errObj.passwordErr}
              helpertext={errObj.passwordMsg}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />

            <Typography
              onClick={() => navigate("/forgot-password")}
              className={classes.menuTitleStyle}
              sx={{ textAlign: "right", cursor: "pointer", color: "#4D6BF6" }}
            >
              Forgot your password?
            </Typography>

            <Stack
              direction="column"
              spacing={2}
              justifyContent="center"
              alignItems={"center"}
            >
              <center>
                <button
                  style={{
                    marginTop: isTablet ? "1vh " : "2vh",
                    width: "fit-content",
                    padding: isMobile
                      ? "1.5vh 10vw"
                      : isTablet
                      ? "1.5vh 2vw"
                      : "1.5vh 2vw",
                    backgroundColor: "#4D6BF6",
                    borderRadius: "12px",
                    fontSize: isTablet ? "14px" : "16px",
                    fontWeight: "600",
                    boxShadow: "none",
                    border: "1px solid transparent",
                    color: "#fff",
                    cursor: "pointer",
                    fontFamily: "Inter Tight",
                    textAlign: "center",
                  }}
                  onClick={validation}
                  disabled={btnLoad}
                >
                  {btnLoad ? (
                    <CircularProgress size={24} sx={{ color: "#fff" }} />
                  ) : (
                    "Log in to dashboard"
                  )}
                </button>
              </center>
              <img src={Images.divider} alt="divider" />

              <GoogleOAuthProvider clientId={Setting.GOOGLE_CLIENT_ID}>
                <GoogleLoginButton
                  loader={socialBtnLoad === "google"}
                  onGoogleDone={(val) => googleDataApiCall(val?.code)}
                />
              </GoogleOAuthProvider>
            </Stack>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default NewLogin;
